import React from "react";
import classNames from "classnames";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

const DateInput = ({ defaultValue, id, name, label, updateOnChange, invalid, popperModifiers, popperPlacement, minDate, showIcon, toggleCalendarOnIconClick, placeholderText }) => {
    const htmlLabel = label ? <label htmlFor={name || id}>{label}:</label> : null;

    const handleChange = (date) => {
        if (updateOnChange) {
            updateOnChange(id || name, date);
        }
    };

    return (
        <div className={classNames("form-field", { "-error": !!invalid })}>
            {htmlLabel}
            <DatePicker id={id} name={name} selected={defaultValue && new Date(defaultValue)} onChange={handleChange} isClearable={!!defaultValue} autoComplete="off" popperModifiers={popperModifiers || []} popperPlacement={popperPlacement} minDate={minDate} showIcon={showIcon} toggleCalendarOnIconClick={toggleCalendarOnIconClick} placeholderText={placeholderText} />
        </div>
    );
};

export default DateInput;
